import React, { useEffect, useMemo, useState } from "react";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/lessons/searchbar";
import LessonsTable from "../../../containers/admin/lessons/table";
import { getAllLessonsRequest } from "../../../modules/admin-modules/lessons/Actions";
import { useDispatch, useSelector } from "react-redux";
import AddLesson from "../../../containers/admin/lessons/models/add-lesson";
import { getAllAdminSectionsRequest } from "../../../modules/admin-modules/sections/Actions";

const Lessons = () => {
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [selectedSectionIds, setSelectedSectionIds] = useState([]);
  const dispatch = useDispatch();
  const lessons = useSelector((state) => state.lessons.lessons);

  useEffect(() => {
    dispatch(getAllLessonsRequest());
    dispatch(getAllAdminSectionsRequest());
  }, []);

  const filteredLessons = useMemo(() => {
    if (!selectedSectionIds.length) return lessons;

    return lessons?.filter((lesson) =>
      selectedSectionIds.some(
        (sectionId) => String(sectionId) === String(lesson?.chapter?.section_id)
      )
    );
  }, [lessons, selectedSectionIds]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        selectedSectionIds={selectedSectionIds}
        setSelectedSectionIds={setSelectedSectionIds}
        lessonCount={filteredLessons?.length ?? 0}
      />
      <LessonsTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        lessons={filteredLessons}
      />
      <AddLesson
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default Lessons;
